<template>
  <CompanyDiscussionsContainer />
</template>
<script>

import CompanyDiscussionsContainer from '@/modules/companyDiscussions'
import companyPageMixin from '@/mixins/companyPageMixin'

import { useCompaniesStore } from '../stores/companies'

export default {
  name: 'CompanyDiscussions',
  components: {
    CompanyDiscussionsContainer
  },
  mixins: [companyPageMixin],
  setup() {
    const companiesStore = useCompaniesStore()

    return { companiesStore }
  },
  metaInfo () {
    return {
      title: `${this.companyName}  ${this.$t('Discussion')}`
    }
  },
  computed: {
    company() {
        return this.companiesStore.selectedCompany 
    },
    loading() {
        return this.companiesStore.loading 
    },
    companyName () {
      if (!this.company) return `${this.$t('Company')}`
      return this.company.name
    }
  }
}
</script>
